import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withAuthentication } from '~/hocs/withAuthentication';
import { useTeamsListQuery } from '~/pages/teams/queries';
import { Table } from '~/components/Table/Table';
import { TeamRow } from './components/team-row';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

const List = withAuthentication(({ user }) => {
  const currentYear = new Date().getFullYear();
  const clubId = user.permissions.clubs_admin.map(club => club.id)[0];
  const { data, isLoading } = useTeamsListQuery({ year: currentYear, club: clubId });

  if (user.permissions.federation_admin) {
    return (
      <Fragment>
        <p>Genom att du är förbundsadministratör så har du rättigheter till alla lag.</p>
        <p>
          Därför bör du istället använda dig utav <Link to="/series/teams">lagregistret</Link>, som du även kommer åt
          via huvudmenyn.
        </p>
      </Fragment>
    );
  }

  if (!user.permissions.clubs_admin.length) {
    return <p>Du har inga föreningar som du administrerar för tillfället, och därmed inga lag.</p>;
  }

  if (isLoading) {
    return (
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Lag</Table.Col>
            <Table.Col as="th">Serie</Table.Col>
            <Table.Col as="th">Nivå</Table.Col>
            <Table.Col as="th">Serie 1</Table.Col>
            <Table.Col as="th">Serie 2</Table.Col>
            <Table.Col as="th">Serie 3</Table.Col>
            <Table.Col as="th">Serie 4</Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          <Table.Loading cols={7} />
        </Table.Body>
      </Table>
    );
  }

  if (!data?.results.length) {
    return <p>Du har inga lag registrerade i dina föreningar.</p>;
  }

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Lag</Table.Col>
          <Table.Col as="th">Serie</Table.Col>
          <Table.Col as="th">Nivå</Table.Col>
          <Table.Col as="th">Serie 1</Table.Col>
          <Table.Col as="th">Serie 2</Table.Col>
          <Table.Col as="th">Serie 3</Table.Col>
          <Table.Col as="th">Serie 4</Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {data?.results.map(team => (
          <TeamRow key={team.id} teamId={team.id} divisionId={team.division.id} />
        ))}
      </Table.Body>
    </Table>
  );
});

export function Page() {
  const currentYear = new Date().getFullYear();

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={`Mina lag (${currentYear})`} />
      </PageLayout.Header>

      <List />
    </Fragment>
  );
}
